"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LeadingIcon = exports.optionStyles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _Dropdown = require("@emcasa/ui/lib/components/Dropdown");

var _Icon = _interopRequireDefault(require("../Icon"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 0 0 ", "px;\n  margin-right: ", "px;\n\n  svg {\n    width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 0 0 ", "px;\n  height: ", "px;\n  margin-right: ", "px;\n  border: 1px solid ", ";\n  border-radius: 100%;\n\n  &::after {\n    content: '';\n    width: 16px;\n    height: 16px;\n    background-color: ", ";\n    transition: transform 0.45s cubic-bezier(0.4, 0.2, 0, 1);\n    border-radius: 100%;\n    transform: scale(", ");\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  color: ", ";\n  touch-action: manipulation;\n  user-select: none;\n  outline: none;\n  cursor: pointer;\n  &:hover,\n  &:focus {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  flex: 0 0 ", "px;\n  padding: 0 ", "px;\n  box-sizing: border-box;\n  overflow: hidden;\n  font-family: ", ";\n  font-size: ", "px;\n  line-height: 20px;\n  text-align: left;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RADIO_WIDTH = 22;
var optionStyles = (0, _styledComponents.css)(_templateObject(), (0, _themeGet.themeGet)('buttonHeight.0'), (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('fontFamily'), (0, _themeGet.themeGet)('buttonFontSize.0'), (0, _themeGet.themeGet)('colors.white'));
exports.optionStyles = optionStyles;

var Button = _styledComponents["default"].li(_templateObject2(), optionStyles, (0, _themeGet.themeGet)('colors.grey900'), (0, _themeGet.themeGet)('colors.grey100'));

var Radio = _styledComponents["default"].span(_templateObject3(), RADIO_WIDTH, RADIO_WIDTH, (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('colors.grey900'), (0, _themeGet.themeGet)('colors.grey900'), function (_ref) {
  var selected = _ref.selected;
  return selected ? '1' : '0';
});

var LeadingIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  width: RADIO_WIDTH,
  height: '100%'
})(_templateObject4(), RADIO_WIDTH, (0, _themeGet.themeGet)('space.3'));
exports.LeadingIcon = LeadingIcon;

var DropdownOption = function DropdownOption(_ref2) {
  var children = _ref2.children,
      selected = _ref2.selected,
      onSelect = _ref2.onSelect,
      iconProps = _ref2.iconProps;
  return _react["default"].createElement(Button, {
    role: "option",
    "aria-selected": selected,
    tabIndex: 0,
    onMouseDown: onSelect
  }, iconProps ? _react["default"].createElement(LeadingIcon, iconProps) : _react["default"].createElement(Radio, {
    selected: selected
  }), children);
};

DropdownOption.displayName = 'DropdownOption';
DropdownOption.propTypes = _Dropdown.option.propTypes;
DropdownOption.defaultProps = _Dropdown.option.defaultProps;
var _default = DropdownOption;
exports["default"] = _default;